const updateCartCount = (count) => {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
  });
};

export default updateCartCount;
